/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { thirdparty_ApiCallLogListResponse } from '../models/thirdparty_ApiCallLogListResponse';
import type { thirdparty_ApiCallLogResponse } from '../models/thirdparty_ApiCallLogResponse';
import type { thirdparty_BulkDeleteProductsRequest } from '../models/thirdparty_BulkDeleteProductsRequest';
import type { thirdparty_BulkDeleteProductsResponse } from '../models/thirdparty_BulkDeleteProductsResponse';
import type { thirdparty_BulkDeleteSuppliersRequest } from '../models/thirdparty_BulkDeleteSuppliersRequest';
import type { thirdparty_BulkDeleteSuppliersResponse } from '../models/thirdparty_BulkDeleteSuppliersResponse';
import type { thirdparty_BulkImportProductsRequest } from '../models/thirdparty_BulkImportProductsRequest';
import type { thirdparty_BulkImportProductsResponse } from '../models/thirdparty_BulkImportProductsResponse';
import type { thirdparty_BulkImportSuppliersRequest } from '../models/thirdparty_BulkImportSuppliersRequest';
import type { thirdparty_BulkImportSuppliersResponse } from '../models/thirdparty_BulkImportSuppliersResponse';
import type { thirdparty_BulkUpdateProductsRequest } from '../models/thirdparty_BulkUpdateProductsRequest';
import type { thirdparty_BulkUpdateProductsResponse } from '../models/thirdparty_BulkUpdateProductsResponse';
import type { thirdparty_BulkUpdateSuppliersRequest } from '../models/thirdparty_BulkUpdateSuppliersRequest';
import type { thirdparty_BulkUpdateSuppliersResponse } from '../models/thirdparty_BulkUpdateSuppliersResponse';
import type { thirdparty_CreateSettlementRequest } from '../models/thirdparty_CreateSettlementRequest';
import type { thirdparty_EventInventoryAllocateRequest } from '../models/thirdparty_EventInventoryAllocateRequest';
import type { thirdparty_EventInventoryAllocateResponse } from '../models/thirdparty_EventInventoryAllocateResponse';
import type { thirdparty_EventInventoryStatsResponse } from '../models/thirdparty_EventInventoryStatsResponse';
import type { thirdparty_EventProductAssignmentCreateRequest } from '../models/thirdparty_EventProductAssignmentCreateRequest';
import type { thirdparty_EventProductAssignmentListResponse } from '../models/thirdparty_EventProductAssignmentListResponse';
import type { thirdparty_EventProductAssignmentResponse } from '../models/thirdparty_EventProductAssignmentResponse';
import type { thirdparty_EventProductAssignmentUpdateRequest } from '../models/thirdparty_EventProductAssignmentUpdateRequest';
import type { thirdparty_FulfillmentListResponse } from '../models/thirdparty_FulfillmentListResponse';
import type { thirdparty_FulfillmentResponse } from '../models/thirdparty_FulfillmentResponse';
import type { thirdparty_FulfillmentStatsResponse } from '../models/thirdparty_FulfillmentStatsResponse';
import type { thirdparty_InventoryImportRequest } from '../models/thirdparty_InventoryImportRequest';
import type { thirdparty_InventoryImportResponse } from '../models/thirdparty_InventoryImportResponse';
import type { thirdparty_InventoryListResponse } from '../models/thirdparty_InventoryListResponse';
import type { thirdparty_InventoryStatsResponse } from '../models/thirdparty_InventoryStatsResponse';
import type { thirdparty_ProductCreateRequest } from '../models/thirdparty_ProductCreateRequest';
import type { thirdparty_ProductListResponse } from '../models/thirdparty_ProductListResponse';
import type { thirdparty_ProductResponse } from '../models/thirdparty_ProductResponse';
import type { thirdparty_ProductUpdateRequest } from '../models/thirdparty_ProductUpdateRequest';
import type { thirdparty_ReconciliationListResponse } from '../models/thirdparty_ReconciliationListResponse';
import type { thirdparty_ReconciliationResponse } from '../models/thirdparty_ReconciliationResponse';
import type { thirdparty_SettlementListResponse } from '../models/thirdparty_SettlementListResponse';
import type { thirdparty_SettlementResponse } from '../models/thirdparty_SettlementResponse';
import type { thirdparty_SupplierCreateRequest } from '../models/thirdparty_SupplierCreateRequest';
import type { thirdparty_SupplierListResponse } from '../models/thirdparty_SupplierListResponse';
import type { thirdparty_SupplierResponse } from '../models/thirdparty_SupplierResponse';
import type { thirdparty_SupplierUpdateRequest } from '../models/thirdparty_SupplierUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ThirdpartyService {
    /**
     * Allocate inventory to event
     * Allocate codes from global pool to an event for a specific product
     * @param organizer Organizer slug
     * @param event Event slug
     * @param request Allocation request
     * @returns thirdparty_EventInventoryAllocateResponse Allocation successful
     * @throws ApiError
     */
    public static postOrganizersEventsThirdpartyInventoryAllocate(
        organizer: string,
        event: string,
        request: thirdparty_EventInventoryAllocateRequest,
    ): CancelablePromise<thirdparty_EventInventoryAllocateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/thirdparty/inventory/allocate',
            path: {
                'organizer': organizer,
                'event': event,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get event inventory statistics
     * Get aggregate inventory statistics for all products in an event
     * @param organizer Organizer slug
     * @param event Event slug
     * @returns thirdparty_EventInventoryStatsResponse Inventory statistics
     * @throws ApiError
     */
    public static getOrganizersEventsThirdpartyInventoryStats(
        organizer: string,
        event: string,
    ): CancelablePromise<thirdparty_EventInventoryStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}/thirdparty/inventory/stats',
            path: {
                'organizer': organizer,
                'event': event,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List event products
     * Get paginated list of products assigned to an event
     * @param organizer Organizer slug
     * @param event Event slug
     * @param limit Items per page
     * @param offset Pagination offset
     * @param active Filter by active status
     * @returns thirdparty_EventProductAssignmentListResponse Paginated list of event products
     * @throws ApiError
     */
    public static getOrganizersEventsThirdpartyProducts(
        organizer: string,
        event: string,
        limit: number = 20,
        offset?: number,
        active?: boolean,
    ): CancelablePromise<thirdparty_EventProductAssignmentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}/thirdparty/products',
            path: {
                'organizer': organizer,
                'event': event,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'active': active,
            },
            errors: {
                400: `Invalid parameters`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Assign product to event
     * Assign an organization-level product to an event with event-specific configuration
     * @param organizer Organizer slug
     * @param event Event slug
     * @param request Assignment creation data
     * @returns thirdparty_EventProductAssignmentResponse Product assigned successfully
     * @throws ApiError
     */
    public static postOrganizersEventsThirdpartyProducts(
        organizer: string,
        event: string,
        request: thirdparty_EventProductAssignmentCreateRequest,
    ): CancelablePromise<thirdparty_EventProductAssignmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/thirdparty/products',
            path: {
                'organizer': organizer,
                'event': event,
            },
            body: request,
            errors: {
                400: `Invalid request body`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update event product assignment
     * Update event-specific configuration for a product assignment
     * @param organizer Organizer slug
     * @param event Event slug
     * @param assignmentId Assignment ID
     * @param request Update data
     * @returns thirdparty_EventProductAssignmentResponse Assignment updated successfully
     * @throws ApiError
     */
    public static putOrganizersEventsThirdpartyProducts(
        organizer: string,
        event: string,
        assignmentId: number,
        request: thirdparty_EventProductAssignmentUpdateRequest,
    ): CancelablePromise<thirdparty_EventProductAssignmentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/events/{event}/thirdparty/products/{assignment_id}',
            path: {
                'organizer': organizer,
                'event': event,
                'assignment_id': assignmentId,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Assignment not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Unassign product from event
     * Remove a product from an event
     * @param organizer Organizer slug
     * @param event Event slug
     * @param assignmentId Assignment ID
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersEventsThirdpartyProducts(
        organizer: string,
        event: string,
        assignmentId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/events/{event}/thirdparty/products/{assignment_id}',
            path: {
                'organizer': organizer,
                'event': event,
                'assignment_id': assignmentId,
            },
            errors: {
                404: `Assignment not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Danh sách audit log request/response gọi ra API 3rd-party supplier
     * Chỉ org_admin. Không trả headers/body đầy đủ (chỉ metadata) — xem chi tiết 1 dòng
     * qua GET .../api-call-logs/{id}.
     * @param organizer Organizer slug
     * @param supplierId Filter by supplier ID
     * @param productId Filter by product ID
     * @param orderCode Filter by order code (partial match)
     * @param callType Filter: create_booking | check_status | issue_ticket
     * @param status Filter: success | failed | error
     * @param periodStart Filter from (RFC3339, theo created)
     * @param periodEnd Filter to (RFC3339, theo created)
     * @param limit Page size
     * @param offset Page offset
     * @returns thirdparty_ApiCallLogListResponse OK
     * @throws ApiError
     */
    public static getOrganizersThirdpartyApiCallLogs(
        organizer: string,
        supplierId?: number,
        productId?: number,
        orderCode?: string,
        callType?: string,
        status?: string,
        periodStart?: string,
        periodEnd?: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<thirdparty_ApiCallLogListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/api-call-logs',
            path: {
                'organizer': organizer,
            },
            query: {
                'supplier_id': supplierId,
                'product_id': productId,
                'order_code': orderCode,
                'call_type': callType,
                'status': status,
                'period_start': periodStart,
                'period_end': periodEnd,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Chi tiết 1 audit log — đầy đủ request/response headers + body
     * Chỉ org_admin.
     * @param organizer Organizer slug
     * @param id API call log ID
     * @returns thirdparty_ApiCallLogResponse OK
     * @throws ApiError
     */
    public static getOrganizersThirdpartyApiCallLogs1(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_ApiCallLogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/api-call-logs/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * List fulfillments
     * Get paginated list of fulfillment requests
     * @param organizer Organizer slug
     * @param limit Items per page
     * @param offset Pagination offset
     * @returns thirdparty_FulfillmentListResponse Paginated list of fulfillments
     * @throws ApiError
     */
    public static getOrganizersThirdpartyFulfillments(
        organizer: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<thirdparty_FulfillmentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/fulfillments',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get fulfillment statistics
     * Get fulfillment statistics (counts by status, success rate, average time)
     * @param organizer Organizer slug
     * @param supplierId Filter by supplier ID
     * @param days Statistics period in days
     * @returns thirdparty_FulfillmentStatsResponse Fulfillment statistics
     * @throws ApiError
     */
    public static getOrganizersThirdpartyFulfillmentsStats(
        organizer: string,
        supplierId?: number,
        days: number = 30,
    ): CancelablePromise<thirdparty_FulfillmentStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/fulfillments/stats',
            path: {
                'organizer': organizer,
            },
            query: {
                'supplier_id': supplierId,
                'days': days,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get fulfillment by ID
     * Retrieve detailed information about a specific fulfillment request
     * @param organizer Organizer slug
     * @param id Fulfillment ID
     * @returns thirdparty_FulfillmentResponse Fulfillment details
     * @throws ApiError
     */
    public static getOrganizersThirdpartyFulfillments1(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_FulfillmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/fulfillments/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Fulfillment not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List inventory codes
     * Get paginated list of inventory codes for a product
     * @param organizer Organizer slug
     * @param productId Filter by product ID
     * @param limit Items per page
     * @param offset Pagination offset
     * @returns thirdparty_InventoryListResponse Paginated list of inventory codes
     * @throws ApiError
     */
    public static getOrganizersThirdpartyInventory(
        organizer: string,
        productId: number,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<thirdparty_InventoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/inventory',
            path: {
                'organizer': organizer,
            },
            query: {
                'product_id': productId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid product_id`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Import inventory codes from CSV
     * Import inventory codes from CSV data for a product
     * @param organizer Organizer slug
     * @param request CSV import data
     * @returns thirdparty_InventoryImportResponse Import result with statistics
     * @throws ApiError
     */
    public static postOrganizersThirdpartyInventoryImport(
        organizer: string,
        request: thirdparty_InventoryImportRequest,
    ): CancelablePromise<thirdparty_InventoryImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/inventory/import',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid CSV format or validation error`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get inventory statistics
     * Get inventory statistics for a product (counts by status)
     * @param organizer Organizer slug
     * @param productId Product ID
     * @returns thirdparty_InventoryStatsResponse Inventory statistics
     * @throws ApiError
     */
    public static getOrganizersThirdpartyInventoryStats(
        organizer: string,
        productId: number,
    ): CancelablePromise<thirdparty_InventoryStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/inventory/stats/{product_id}',
            path: {
                'organizer': organizer,
                'product_id': productId,
            },
            errors: {
                400: `Invalid product_id`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List products
     * Get paginated list of third-party products
     * @param organizer Organizer slug
     * @param limit Items per page
     * @param offset Pagination offset
     * @returns thirdparty_ProductListResponse Paginated list of products
     * @throws ApiError
     */
    public static getOrganizersThirdpartyProducts(
        organizer: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<thirdparty_ProductListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/products',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create new product
     * Create a new third-party product linked to an item
     * @param organizer Organizer slug
     * @param request Product creation data
     * @returns thirdparty_ProductResponse Product created successfully
     * @throws ApiError
     */
    public static postOrganizersThirdpartyProducts(
        organizer: string,
        request: thirdparty_ProductCreateRequest,
    ): CancelablePromise<thirdparty_ProductResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/products',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request body`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk delete products
     * Delete multiple products by IDs (soft delete)
     * @param organizer Organizer slug
     * @param request Bulk delete request
     * @returns thirdparty_BulkDeleteProductsResponse Bulk delete results
     * @throws ApiError
     */
    public static deleteOrganizersThirdpartyProductsBulkDelete(
        organizer: string,
        request: thirdparty_BulkDeleteProductsRequest,
    ): CancelablePromise<thirdparty_BulkDeleteProductsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/thirdparty/products/bulk/delete',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk import products
     * Import multiple products (create or upsert mode). Max 1000 products per request.
     * @param organizer Organizer slug
     * @param request Bulk import request
     * @returns thirdparty_BulkImportProductsResponse Bulk import results
     * @throws ApiError
     */
    public static postOrganizersThirdpartyProductsBulkImport(
        organizer: string,
        request: thirdparty_BulkImportProductsRequest,
    ): CancelablePromise<thirdparty_BulkImportProductsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/products/bulk/import',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk update products
     * Update multiple products by IDs
     * @param organizer Organizer slug
     * @param request Bulk update request
     * @returns thirdparty_BulkUpdateProductsResponse Bulk update results
     * @throws ApiError
     */
    public static patchOrganizersThirdpartyProductsBulkUpdate(
        organizer: string,
        request: thirdparty_BulkUpdateProductsRequest,
    ): CancelablePromise<thirdparty_BulkUpdateProductsResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/organizers/{organizer}/thirdparty/products/bulk/update',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get product by ID
     * Retrieve detailed information about a specific product
     * @param organizer Organizer slug
     * @param id Product ID
     * @returns thirdparty_ProductResponse Product details
     * @throws ApiError
     */
    public static getOrganizersThirdpartyProducts1(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_ProductResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/products/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update product
     * Update an existing third-party product
     * @param organizer Organizer slug
     * @param id Product ID
     * @param request Product update data
     * @returns thirdparty_ProductResponse Product updated successfully
     * @throws ApiError
     */
    public static putOrganizersThirdpartyProducts(
        organizer: string,
        id: number,
        request: thirdparty_ProductUpdateRequest,
    ): CancelablePromise<thirdparty_ProductResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/thirdparty/products/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete product
     * Delete a third-party product (soft delete)
     * @param organizer Organizer slug
     * @param id Product ID
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersThirdpartyProducts(
        organizer: string,
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/thirdparty/products/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Product not found`,
                409: `Product has inventory/fulfillments/assignments`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Trigger stock reconciliation
     * Manually recompute a product's stock/reserved counters from third_party_inventory and record a reconciliation history row (project-management task 008)
     * @param organizer Organizer slug
     * @param id Product ID
     * @returns thirdparty_ReconciliationResponse Reconciliation result
     * @throws ApiError
     */
    public static postOrganizersThirdpartyProductsReconcile(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_ReconciliationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/products/{id}/reconcile',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid product ID`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List stock reconciliation history
     * List past reconciliation checks for a product, most recent first (project-management task 008)
     * @param organizer Organizer slug
     * @param id Product ID
     * @param limit Max rows
     * @returns thirdparty_ReconciliationListResponse Reconciliation history
     * @throws ApiError
     */
    public static getOrganizersThirdpartyProductsReconciliationHistory(
        organizer: string,
        id: number,
        limit: number = 50,
    ): CancelablePromise<thirdparty_ReconciliationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/products/{id}/reconciliation-history',
            path: {
                'organizer': organizer,
                'id': id,
            },
            query: {
                'limit': limit,
            },
            errors: {
                400: `Invalid product ID`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List settlements
     * List settlement runs for the organizer, optionally filtered by supplier/status (project-management task 008)
     * @param organizer Organizer slug
     * @param supplierId Filter by supplier ID
     * @param status Filter by status: draft, confirmed, paid
     * @param periodStart Filter: settlement period overlaps from this date (RFC3339)
     * @param periodEnd Filter: settlement period overlaps until this date (RFC3339)
     * @param limit Page size
     * @param offset Page offset
     * @returns thirdparty_SettlementListResponse Settlements
     * @throws ApiError
     */
    public static getOrganizersThirdpartySettlements(
        organizer: string,
        supplierId?: number,
        status?: string,
        periodStart?: string,
        periodEnd?: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<thirdparty_SettlementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/settlements',
            path: {
                'organizer': organizer,
            },
            query: {
                'supplier_id': supplierId,
                'status': status,
                'period_start': periodStart,
                'period_end': periodEnd,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create a settlement run
     * Compute a draft settlement for a supplier covering a period, aggregating sold third-party inventory by product (project-management task 008)
     * @param organizer Organizer slug
     * @param request Settlement period
     * @returns thirdparty_SettlementResponse Created settlement
     * @throws ApiError
     */
    public static postOrganizersThirdpartySettlements(
        organizer: string,
        request: thirdparty_CreateSettlementRequest,
    ): CancelablePromise<thirdparty_SettlementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/settlements',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a settlement
     * Retrieve one settlement run with its line items (project-management task 008)
     * @param organizer Organizer slug
     * @param id Settlement ID
     * @returns thirdparty_SettlementResponse Settlement details
     * @throws ApiError
     */
    public static getOrganizersThirdpartySettlements1(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_SettlementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/settlements/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Settlement not found`,
            },
        });
    }
    /**
     * Confirm a settlement
     * Transition a draft settlement to confirmed (project-management task 008)
     * @param organizer Organizer slug
     * @param id Settlement ID
     * @returns thirdparty_SettlementResponse Confirmed settlement
     * @throws ApiError
     */
    public static postOrganizersThirdpartySettlementsConfirm(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_SettlementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/settlements/{id}/confirm',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid transition`,
            },
        });
    }
    /**
     * Mark a settlement paid
     * Transition a confirmed settlement to paid (project-management task 008)
     * @param organizer Organizer slug
     * @param id Settlement ID
     * @returns thirdparty_SettlementResponse Paid settlement
     * @throws ApiError
     */
    public static postOrganizersThirdpartySettlementsMarkPaid(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_SettlementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/settlements/{id}/mark-paid',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid transition`,
            },
        });
    }
    /**
     * List suppliers
     * Get paginated list of third-party suppliers with optional filtering
     * @param organizer Organizer slug
     * @param limit Items per page
     * @param offset Pagination offset
     * @param supplierType Filter by supplier type (csv or api)
     * @param active Filter by active status
     * @returns thirdparty_SupplierListResponse Paginated list of suppliers
     * @throws ApiError
     */
    public static getOrganizersThirdpartySuppliers(
        organizer: string,
        limit: number = 20,
        offset?: number,
        supplierType?: string,
        active?: boolean,
    ): CancelablePromise<thirdparty_SupplierListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/suppliers',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'supplier_type': supplierType,
                'active': active,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create new supplier
     * Create a new third-party supplier (CSV or API based)
     * @param organizer Organizer slug
     * @param request Supplier creation data
     * @returns thirdparty_SupplierResponse Supplier created successfully
     * @throws ApiError
     */
    public static postOrganizersThirdpartySuppliers(
        organizer: string,
        request: thirdparty_SupplierCreateRequest,
    ): CancelablePromise<thirdparty_SupplierResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/suppliers',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request body`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk delete suppliers
     * Delete multiple suppliers at once (soft delete, blocks if products exist). Max 1000 suppliers per request.
     * @param organizer Organizer slug
     * @param request Bulk delete data
     * @returns thirdparty_BulkDeleteSuppliersResponse Delete results with counts and errors
     * @throws ApiError
     */
    public static deleteOrganizersThirdpartySuppliersBulkDelete(
        organizer: string,
        request: thirdparty_BulkDeleteSuppliersRequest,
    ): CancelablePromise<thirdparty_BulkDeleteSuppliersResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/thirdparty/suppliers/bulk-delete',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request or size limit exceeded`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk import suppliers
     * Import multiple suppliers (create or upsert mode). Max 1000 suppliers per request.
     * @param organizer Organizer slug
     * @param request Bulk import data
     * @returns thirdparty_BulkImportSuppliersResponse Import results with counts and errors
     * @throws ApiError
     */
    public static postOrganizersThirdpartySuppliersBulkImport(
        organizer: string,
        request: thirdparty_BulkImportSuppliersRequest,
    ): CancelablePromise<thirdparty_BulkImportSuppliersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/suppliers/bulk-import',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request or size limit exceeded`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Bulk update suppliers
     * Update multiple suppliers at once. Max 1000 suppliers per request.
     * @param organizer Organizer slug
     * @param request Bulk update data
     * @returns thirdparty_BulkUpdateSuppliersResponse Update results with counts and errors
     * @throws ApiError
     */
    public static postOrganizersThirdpartySuppliersBulkUpdate(
        organizer: string,
        request: thirdparty_BulkUpdateSuppliersRequest,
    ): CancelablePromise<thirdparty_BulkUpdateSuppliersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/thirdparty/suppliers/bulk-update',
            path: {
                'organizer': organizer,
            },
            body: request,
            errors: {
                400: `Invalid request or size limit exceeded`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get supplier by ID
     * Retrieve detailed information about a specific supplier
     * @param organizer Organizer slug
     * @param id Supplier ID
     * @returns thirdparty_SupplierResponse Supplier details
     * @throws ApiError
     */
    public static getOrganizersThirdpartySuppliers1(
        organizer: string,
        id: number,
    ): CancelablePromise<thirdparty_SupplierResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/thirdparty/suppliers/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Supplier not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update supplier
     * Update an existing third-party supplier
     * @param organizer Organizer slug
     * @param id Supplier ID
     * @param request Supplier update data
     * @returns thirdparty_SupplierResponse Supplier updated successfully
     * @throws ApiError
     */
    public static putOrganizersThirdpartySuppliers(
        organizer: string,
        id: number,
        request: thirdparty_SupplierUpdateRequest,
    ): CancelablePromise<thirdparty_SupplierResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/thirdparty/suppliers/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                404: `Supplier not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete supplier
     * Soft delete a third-party supplier (blocks if products exist)
     * @param organizer Organizer slug
     * @param id Supplier ID
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersThirdpartySuppliers(
        organizer: string,
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/thirdparty/suppliers/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                404: `Supplier not found`,
                409: `Supplier has products`,
                500: `Internal server error`,
            },
        });
    }
}
